export enum EConsigmentMode {
  Basic = 0,
  Consent = 1,
  Signed = 2,
  Other = 3,
}
